import { createRoot } from 'react-dom/client'
import App from './App'
import 'flexlayout-react/style/light.css'
import './styles.css'

// No StrictMode: the edit-lock effects (acquire/release on mount/unmount) should
// fire once per tab, not be double-invoked in dev.
createRoot(document.getElementById('root')!).render(<App />)
